import { createSlice } from '@reduxjs/toolkit';

const buyerSlice = createSlice({
  name: 'buyer',
  initialState: {
    selectedGameRunId: null,
    selectedGroupIds: [], // Array of selected group IDs
  },
  reducers: {
    setSelectedGameRunId: (state, action) => {
      state.selectedGameRunId = action.payload;
      // Reset selected groups when changing GameRun
      state.selectedGroupIds = [];
    },
    setSelectedGroupIds: (state, action) => {
      state.selectedGroupIds = action.payload;
    },
    toggleGroupId: (state, action) => {
      const groupId = action.payload;
      const index = state.selectedGroupIds.indexOf(groupId);
      if (index > -1) {
        // Remove the group
        state.selectedGroupIds.splice(index, 1);
      } else {
        // Add the group
        state.selectedGroupIds.push(groupId);
      }
    },
    selectAllGroups: (state, action) => {
      // action.payload contains all available group IDs
      state.selectedGroupIds = action.payload;
    },
    clearSelectedGroups: (state) => {
      state.selectedGroupIds = [];
    },
  },
});

export const {
  setSelectedGameRunId,
  setSelectedGroupIds,
  toggleGroupId,
  selectAllGroups,
  clearSelectedGroups,
} = buyerSlice.actions;

export const selectSelectedGameRunId = (state) => state.buyer.selectedGameRunId;
export const selectSelectedGroupIds = (state) => state.buyer.selectedGroupIds;

export default buyerSlice.reducer;
